import React from "react";
// import { useBox, usePlane } from "@react-three/cannon";
// import * as THREE from "three";
// import {useFrame} from "@react-three/fiber"
import {useRigidBody, BodyType, ShapeType} from 'use-ammojs'

// let i = 0

const SideBoundary = ({ size }) => {
  // const [ref] = usePlane(() => ({ position: [0, 5, -137] }));
  // const [ref2] = usePlane(() => ({
  //   position: [0, 5, 135],
  //   rotation: [0, Math.PI, 0]
  // }));
  // const [ref3] = usePlane(() => ({
  //   position: [(size+47)/2, 5, 0],
  //   rotation: [0, -Math.PI / 2, 0]
  // }));
  // const [ref4] = usePlane(() => ({
  //   position: [-(size+47)/2, 5, 0],
  //   rotation: [0, Math.PI / 2, 0]
  // }));

  const [ref] = useRigidBody(() => ({
    bodyType: BodyType.STATIC,
    shapeType: ShapeType.BOX,
    position : [0, 5, -137]
  }))

  const [ref2] = useRigidBody(() => ({
    bodyType: BodyType.STATIC,
    shapeType: ShapeType.BOX,
    position : [0, 5, 135]
  }))

  const [ref3] = useRigidBody(() => ({
    bodyType: BodyType.STATIC,
    shapeType: ShapeType.BOX,
    position : [(size+47)/2, 5, 0]
  }))

  const [ref4] = useRigidBody(() => ({
    bodyType: BodyType.STATIC,
    shapeType: ShapeType.BOX,
    position : [-(size+47)/2, 5, 0]
  }))





  return (
    <>
      <mesh 
        ref={ref}
      >
        <boxBufferGeometry args={[size + 50, 10, 0.1]} />
        <meshBasicMaterial
          color="blue"
          visible={false}
        />
      </mesh>
      <mesh 
        ref={ref2}
      >
        <boxBufferGeometry args={[size + 50, 10, 0.1]} />
        <meshBasicMaterial
          color="red"
          visible={false}
        />

      </mesh>
      <mesh 
        ref={ref3}
      >
        <boxBufferGeometry args={[0.1, 10, 500]} />
        <meshBasicMaterial
          color="yellow"
          visible={false}
        />
      </mesh>
      <mesh 
        ref={ref4}
      >
        <boxBufferGeometry args={[0.1, 10,500]} />
        <meshBasicMaterial
          color="pink"
          visible={false}
        />
      </mesh>
      
    </>
  );
};

export default SideBoundary;
